module.exports = __webpack_public_path__ + "static/ToolkitBanner-5c95d7da4a3ad79bac15b5c3653c827c.svg";